/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Avatar, ButtonIcon, Checkbox, Chip, CircularProgress, HelperText, InputBase, Label, Popup, TreeView, Typography } from "../..";
import Popover from "../../popover";
import { getGlobal } from "../../../global";
import PropTypes from 'prop-types';
import { forwardRef, Fragment, memo, useEffect, useImperativeHandle, useLayoutEffect, useMemo, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { animation, bgColor, border, borderBottom, borderBottomColor, borderColor, borderNone, borderRadius, bottom, boxBorder, breakWord, cursorDefault, cursorNotAllowed, cursorPointer, displayBlock, displayFlex, fill, flexRow, flexWrap, gap, inset, insetX, invisible, italic, itemsCenter, justifyCenter, justifyStart, mgb, mgl, mgr, mgt, outlineNone, overflowAuto, overflowHidden, parseHeight, parseMaxHeight, parseMaxWidth, parseMinHeight, parseWidth, parseWidthHeight, pd, pdb, pdl, pdt, pdy, pointerEventsNone, positionAbsolute, positionRelative, textColor, top, userSelectNone, z } from "../../../styles/general";
import { useTheme } from "../../../theme";
import { classNames, isMobile, randomString } from "../../../utils";
const {
  typography: {
    paragraph1
  }
} = useTheme();
const
  // timing = {},
  currentValue = {},
  currentObjectDefault = {},
  isSearch = {},
  allValue = {};
const separatorPattern = /\{\w+\}/g;
const regexBetween = /[^{}]+(?=})/g;
const regexInclude = /{|}/g;
const checkHasValue = value => {
  return Array.isArray(value) ? value.length > 0 : value === 0 || !!value;
};
const convertData = (dt, valueExpr) => {
  let data = dt || [];
  let valueTemp = Array.isArray(data) ? data : [data];
  valueTemp = valueTemp.map(i => i[valueExpr] || i);
  return valueTemp;
};
const convertSearchDelayTime = searchDelayTime => {
  var _searchDelayTime$matc, _searchDelayTime$matc2;
  if (searchDelayTime === true) return getGlobal('delayOnInput');
  const units = {
    m: 60000,
    s: 1000,
    ms: 1
  };
  return typeof searchDelayTime === 'number' ? searchDelayTime : (((_searchDelayTime$matc = searchDelayTime.match(/[^a-z]+/i)) === null || _searchDelayTime$matc === void 0 ? void 0 : _searchDelayTime$matc[0]) || 1) * units[((_searchDelayTime$matc2 = searchDelayTime.match(/ms|s|m/i)) === null || _searchDelayTime$matc2 === void 0 ? void 0 : _searchDelayTime$matc2[0]) || 's'];
};
const Dropdown = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  action = {},
  allowSearch,
  children,
  className,
  clearAble,
  closeAfterSelect,
  dataSource,
  defaultValue,
  disabled,
  displayExpr,
  dropdownItemStyle,
  error,
  helperTextProps,
  iconExpr,
  inputProps,
  inputStyle,
  itemMode,
  label,
  labelProps,
  limit,
  loading,
  maximumSelectionLength,
  multilineSelectedItem,
  multiple,
  noDataText,
  onChange,
  onClosed,
  onInput,
  onKeyDown,
  onLoadMore,
  placeholder,
  readOnly,
  renderItem,
  renderSelectedItem,
  required,
  searchDelayTime,
  searchExpr,
  searchMode,
  selectBox,
  skip,
  style,
  subText,
  total,
  treeViewID,
  treeViewParentID,
  value: valueProp,
  valueExpr,
  valueObjectDefault,
  viewType
}, reference) => {
  if (!reference) reference = useRef(null);
  if (multiple && selectBox === undefined) selectBox = true;
  if (typeof searchExpr === 'string') searchExpr = [searchExpr];
  searchDelayTime = convertSearchDelayTime(searchDelayTime);
  const ref = useRef(null);
  const dropdownRef = useRef(null);
  const timer = useRef(null);
  const timerRef = useRef(null);
  const formRef = useRef(null);
  const inputRef = useRef(null);
  const iconRef = useRef(null);
  const dropdownListRef = useRef(null);
  const searchRef = useRef(null);
  // const lastSearchRef = useRef(null);
  // const timeout = useRef(null);
  const loadMoreTimer = useRef(null);
  const dataChosen = useRef([]);
  const popupRef = useRef(null);
  const filter = useRef({
    skip: skip || 0,
    limit: limit || 50
  });
  const [unique] = useState(randomString(6, {
    allowNumber: false,
    allowSymbol: false
  }));
  const [openState, setOpenState] = useState(false);
  const [showClear, setShowClear] = useState(false);
  const [valueSingle, setValueSingle] = useState('');
  const [txtSearch, setTxtSearch] = useState('');
  const [popoverWidth, setPopoverWidth] = useState(0);
  const [loadingState, setLoadingState] = useState(loading);
  const [totalState, setTotalState] = useState(total);
  const [dataSourceState, setDataSourceState] = useState(dataSource);
  const [popupDataState, setPopupDataState] = useState({
    title: '',
    substitle: '',
    description: ''
  });
  let valueTemp = valueProp || defaultValue || [];

  // only mode multi
  if (multiple) {
    valueTemp = convertData(valueTemp, valueExpr);
  }
  const [valueMulti, setValueMulti] = useState(valueTemp);
  const _isMobile = isMobile.any();
  const _InputCSS = InputCSS(multiple, typeof renderSelectedItem === 'function');
  const _DropdownInputCSS = DropdownInputCSS(viewType, multiple, placeholder, disabled, readOnly, multilineSelectedItem);
  const _IconCSS = IconCSS(viewType);
  const _DropdownFormCSS = DropdownFormCSS(viewType, multiple, disabled, placeholder, _DropdownInputCSS.name);
  const _DropdownListCSS = DropdownListCSS(loadingState);
  const _DropdownItemCSS = DropdownItemCSS(multiple, selectBox);
  const _DropdownRootCSS = DropdownRootCSS(_DropdownFormCSS.name, _DropdownInputCSS.name);

  /* Start handler */
  const setShowDropdown = () => {
    setOpenState(!openState);
  };
  const triggerBlur = (blur = true) => {
    if ((currentValue[unique] || currentValue[unique] === 0) && !multiple) {
      setValueIntoInput(currentValue[unique]);
    } else if (!multiple) {
      setValueIntoInput('');
    }
    !!blur && inputRef.current.blur();
  };
  const onClickInput = e => {
    if (disabled || readOnly || loadingState) return;
    if (!dropdownListRef.current) {
      if (!multiple || !Array.from(inputRef.current.querySelectorAll('.DGN-UI-Chip')).some(item => item.contains(e === null || e === void 0 ? void 0 : e.target))) {
        setOpenState(true);
      }
    }
  };

  // const onClickOutsideOfInput = event => {
  //     if (
  //         inputRef.current &&
  //         !inputRef.current?.contains(event?.target) &&
  //         iconRef.current &&
  //         !iconRef.current?.contains(event?.target) &&
  //         dropdownListRef.current &&
  //         !dropdownListRef.current?.parentNode?.parentNode?.contains(event?.target)
  //     ) {
  //         closeDropdown();
  //         triggerBlur(false);
  //     }
  // };

  const showDropdown = () => {
    // if (displayExpr && Array.isArray(displayExpr)) {
    //     displayExpr = displayExpr.join(' - ');
    // }
    // const keyArr = displayExpr?.match(separatorPattern);
    const dropdown = children ? jsx("div", {
      css: _DropdownListCSS,
      ref: dropdownListRef,
      className: 'DGN-Dropdown-List',
      onKeyDown: moveOnItem,
      tabIndex: -1
    }, dataSourceState !== null && dataSourceState !== void 0 && dataSourceState.length ? children : EmptyDataText) : itemMode === 'normal' ? mapDropdown() : mapTreeView();
    // const { innerHeight } = window;
    // const { top, left, height, width } = formRef.current.getBoundingClientRect();

    // Calculate to set position of Dropdown box
    // const dropdownHeight =
    //     Math.min(
    //         Math.max(
    //             1,
    //             (itemMode === 'normal'
    //                 ? dropdown.props.children
    //                 : mapParent(dataSource, treeViewID, treeViewParentID)
    //             ).length || 1
    //         ),
    //         7
    //     ) *
    //         40 +
    //     (multiple ? 43 : 0);
    // let positionTop = top + height + 4;
    // if (top + height + 4 + dropdownHeight + (allowSearch ? 40 : 0) > innerHeight) {
    //     if (top - dropdownHeight > 0) {
    //         positionTop = top - dropdownHeight;
    //     } else {
    //         positionTop = innerHeight - dropdownHeight;
    //     }
    // }
    // const _DropdownCSS = DropdownCSS(positionTop, left, width, _isMobile, allowSearch);
    const el = jsx(Fragment, null, (multiple || allowSearch) && itemMode === 'normal' && !children ? jsx("div", {
      className: 'DGN-Dropdown-Search'
    }, jsx(InputBase, {
      inputRef: searchRef,
      delayOnChange: searchDelayTime,
      viewType: 'outlined',
      defaultValue: txtSearch,
      onChange: onChangeInput,
      style: {
        marginBottom: 1
      },
      onKeyDown: pressESCHandler,
      readOnly: loadingState,
      autoFocus: true
    })) : null, multiple && maximumSelectionLength ? jsx(Typography, {
      css: pd([2, 4])
    }, getGlobal('selected'), " ", (valueMulti === null || valueMulti === void 0 ? void 0 : valueMulti.length) || 0, "/", maximumSelectionLength) : null, jsx("div", {
      className: 'DGN-Dropdown-Box'
    }, dropdown), loadingState ? jsx("div", {
      css: LoadingProgressCSS,
      className: 'DGN-Dropdown-Loading-Progress'
    }, jsx(CircularProgress, {
      size: 24
    })) : null);
    // if (!((multiple || allowSearch) && itemMode === 'normal' && !children)) {
    // inputRef.current.addEventListener('keydown', pressESCHandler);
    // }
    // document.documentElement.style.overflow = 'hidden';
    setTimeout(() => {
      window.addEventListener('resize', customizeWidthDropdown);
      // document.addEventListener('wheel', onWheelHandler);
      // document.addEventListener('mousedown', onClickOutsideOfInput);
      if (onLoadMore && dataSourceState.length < totalState) {
        dropdownListRef.current && dropdownListRef.current.addEventListener('scroll', onLoadMoreHandler);
      }
    }, 10);
    return el;
  };
  const moveOnItem = e => {
    if (e.key === 'Escape' || e.key === 'Tab') {
      closeDropdown();
      triggerBlur();
    }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      let activeEl = document.activeElement;
      activeEl = e.key === 'ArrowDown' ? activeEl.nextElementSibling : activeEl.previousElementSibling;
      if (activeEl) {
        activeEl.focus();
        activeEl.scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        });
      }
    }
  };
  const pressESCHandler = e => {
    if (e.key === 'Escape' || e.key === 'Tab') {
      closeDropdown();
      triggerBlur();
    } else if (e.key === 'ArrowDown' && dropdownListRef.current) {
      e.preventDefault();
      dropdownListRef.current.firstChild.focus();
    }
  };

  // const onWheelHandler = e => {
  //     if (!dropdownRef.current) {
  //         document.removeEventListener('wheel', onWheelHandler);
  //         return;
  //     }
  //     if (!dropdownRef.current?.contains(e.target)) {
  //         closeDropdown();
  //         triggerBlur();
  //     }
  // };

  const closeDropdown = () => {
    if (dropdownRef.current) {
      setOpenState(false);
      // document.removeEventListener('mousedown', onClickOutsideOfInput);
      window.removeEventListener('resize', customizeWidthDropdown);
      // document.removeEventListener('wheel', onWheelHandler);
      if (onLoadMore && dropdownListRef.current) {
        dropdownListRef.current.removeEventListener('scroll', onLoadMoreHandler);
        dropdownListRef.current = null;
      }
    }
    // document.documentElement.style.overflow = 'auto';
    setTxtSearch('');
    onClosed === null || onClosed === void 0 ? void 0 : onClosed();
  };

  // const renderDropdown = pattern => {
  //     const keyArr = displayExpr?.match(separatorPattern);
  //     const dropdown = mapDropdown(pattern, keyArr);
  //     const el = document.createElement('div');
  //     el.className = `DGN-Dropdown-Box`;
  //     if (dropdownRef.current) {
  //         dropdownRef.current.querySelector('.DGN-Dropdown-Box')?.remove();
  //         ReactDOM.render(dropdown, dropdownRef.current.appendChild(el));
  //         setTimeout(() => {
  //             if (onLoadMore && dataSource.length < total) {
  //                 dropdownListRef.current &&
  //                     dropdownListRef.current.addEventListener('scroll', onLoadMoreHandler);
  //             }
  //             updatePositionDropdown();
  //         }, 0);
  //     }
  // };

  /**
   * So sánh text đầu vào cáo map với txtSearch
   * @param text
   * @return {boolean}
   */
  const handleRenderBySearch = (text = '') => {
    if (typeof text !== 'string') text = text.toString();
    if (!txtSearch) return true;
    if (searchMode === 'startswith') {
      return text.toLowerCase().startsWith(txtSearch.toLowerCase());
    } else if (searchMode === 'equals') {
      return text.toLowerCase() === txtSearch.toLowerCase();
    } else return text.toLowerCase().includes(txtSearch.toLowerCase());
  };

  /**
   * Chuyển đổi data thành giá trị cần hiện thị dựa vào displayExpr [string, string object {field} - {field}], renderSelectedItem, displayExpr, valueExpr
   * @param data {object} rowData of dataSource
   * @return {string}
   */
  const displayValue = data => {
    let text = '';
    if (data || data === 0) {
      displayExpr = displayExpr || valueExpr;
      let mask = data === null || data === void 0 ? void 0 : data[displayExpr];
      // convert {id} - {name} to {<data[id]>} - {<data[name]>}
      if (!mask && regexBetween.test(displayExpr)) {
        var _displayExpr;
        mask = (_displayExpr = displayExpr) === null || _displayExpr === void 0 ? void 0 : _displayExpr.replace(regexBetween, _ => data[_]);
      } else if (!mask) {
        mask = typeof data !== 'object' ? data : '';
      }
      text = mask.toString().replace(regexInclude, '');
    }
    return text;
  };
  const mapDropdown = () => {
    var _currentObjectDefault;
    const items = [];
    let dataSourceUsable = [...dataSourceState];

    // search dataSource dựa trên txtSearch
    if (!onInput || action !== null && action !== void 0 && action.loadData) {
      var _dataSourceUsable;
      dataSourceUsable = (_dataSourceUsable = dataSourceUsable) === null || _dataSourceUsable === void 0 ? void 0 : _dataSourceUsable.filter(i => {
        if (searchExpr) {
          // nếu map đc vs 1 trong những <key>(data[key]) của searchExpr
          return !!searchExpr.find(j => handleRenderBySearch(i[j]));
        } else {
          // nếu map đc vs displayValue
          return handleRenderBySearch(displayValue(i)) || handleRenderBySearch(i === null || i === void 0 ? void 0 : i[valueExpr]);
        }
      });
    }
    if (currentObjectDefault[unique] && (_currentObjectDefault = currentObjectDefault[unique]) !== null && _currentObjectDefault !== void 0 && _currentObjectDefault.length) {
      const length = currentObjectDefault[unique].length;
      let existItemQuantity = 0;
      for (let index = length - 1; index >= 0; index--) {
        if ((currentObjectDefault[unique][index][valueExpr] || currentObjectDefault[unique][index][valueExpr] === 0) && !dataSourceUsable.some(data => data[valueExpr] === currentObjectDefault[unique][index][valueExpr])) {
          dataSourceUsable.unshift(currentObjectDefault[unique][index]);
        } else {
          // Nếu số lượng phần tử của valueObjectDefault tồn tại trong dataSource nhiều hơn hoặc bằng limit thì không remove nữa
          if (++existItemQuantity > limit) {
            continue;
          }
          currentObjectDefault[unique].splice(index, 1);
        }
      }
    }
    const length = dataSourceUsable.length;
    for (let index = 0; index < length; index++) {
      const data = dataSourceUsable[index];
      if (!data) continue;
      const itemHidden = typeof data === 'object' ? data['hidden'] : false;
      if (itemHidden) continue;
      let displayText = displayValue(data);

      // if (searchExpr?.length > 0 && pattern) {
      //     if (handleRenderBySearch(data, pattern)) continue;
      // } else if (pattern && !new RegExp(pattern).test(displayText.normalize())) continue;

      if (subText) {
        displayText = jsx(Fragment, null, jsx(Typography, {
          className: 'DGN-UI-Dropdown-PrimaryText',
          type: 'p1'
        }, displayText), jsx(Typography, {
          className: 'DGN-UI-Dropdown-SubText',
          type: 'p3',
          color: 'text/sub'
        }, typeof subText === 'function' ? subText({
          data,
          index
        }) : data[subText] || subText));
      }
      const value = typeof data === 'object' ? data[valueExpr] : data;
      let itemDisabled = typeof data === 'object' ? data['disabled'] : false;
      const icon = getIconFromData(data);
      const text = renderItem && typeof renderItem === 'function' ? renderItem({
        data,
        index
      }) : jsx(Typography, {
        type: 'p1'
      }, displayText);
      if (multiple && selectBox) {
        const checked = Array.isArray(valueMulti) ? valueMulti.includes(value) : valueMulti.includes(value);
        const isMaximumSelection = maximumSelectionLength === (valueMulti === null || valueMulti === void 0 ? void 0 : valueMulti.length);
        itemDisabled = itemDisabled || isMaximumSelection && !checked;
        items.push(jsx("div", {
          key: index,
          css: !itemDisabled ? _DropdownItemCSS : [DisabledCSS, _DropdownItemCSS],
          className: 'DGN-UI-Dropdown-Item'
          // onClick={() => {
          // if (itemDisabled) return;
          // onChangeValueWithCheckbox(e) & onChangeValue(displayText, value, icon, data, index);
          // onChangeValue(displayText, value, icon, data, index);
          // }}
          ,
          onKeyDown: e => {
            if (itemDisabled) return;
            if (e.key === 'Enter') e.currentTarget.firstChild.click();
            // if (e.key === 'Enter') onChangeValue(displayText, value, icon, data, index);
          },

          tabIndex: -1
        }, jsx(Checkbox, {
          css: CheckBoxCSS,
          forTreeView: true,
          checked: checked,
          value: value,
          disabled: itemDisabled,
          onChange: () => onChangeValue(displayText, value, icon, data, index)
        }, icon, text)));
      } else {
        items.push(jsx("div", {
          key: index,
          css: !itemDisabled ? _DropdownItemCSS : [DisabledCSS, _DropdownItemCSS],
          className: 'DGN-UI-Dropdown-Item',
          onClick: () => {
            if (itemDisabled) return;
            onChangeValue(displayText, value, icon, data, index);
          },
          onKeyDown: e => {
            if (itemDisabled) return;
            if (e.key === 'Enter') onChangeValue(displayText, value, icon, data, index);
          },
          tabIndex: -1,
          style: dropdownItemStyle
        }, icon, text));
      }
    }
    return jsx("div", {
      css: _DropdownListCSS,
      ref: dropdownListRef,
      className: 'DGN-Dropdown-List',
      onKeyDown: moveOnItem,
      tabIndex: -1
    }, items !== null && items !== void 0 && items.length ? items : EmptyDataText);
  };
  const mapTreeView = () => {
    return jsx("div", {
      css: _DropdownListCSS,
      ref: dropdownListRef,
      className: 'DGN-Dropdown-List',
      onKeyDown: moveOnItem,
      tabIndex: -1
    }, dataSourceState !== null && dataSourceState !== void 0 && dataSourceState.length ? jsx(TreeView, {
      dataSource: dataSourceState,
      displayExpr: displayExpr,
      valueExpr: valueExpr,
      multiple: multiple,
      selectBox: selectBox,
      allowSearch: allowSearch,
      searchProps: {
        autoFocus: true,
        inputRef: searchRef
      },
      searchDelayTime: searchDelayTime,
      id: treeViewID,
      parentID: treeViewParentID,
      value: typeof currentValue[unique] === 'string' ? [currentValue[unique]] : currentValue[unique],
      onChange: (e, value) => onChangeValue('', multiple ? value : e.value),
      renderItem: renderItem
    }) : EmptyDataText);
  };

  // remove item  cũ và append child item mới khi load more
  const loadMoreItemsDropdown = (i = 0, pattern) => {
    var _currentObjectDefault2, _displayExpr2;
    const dataSourceUsable = [...dataSourceState];
    // Nếu có load more thì đẩy đội tượng mặc định lên đầu
    let notExistItem = 0;
    if (onLoadMore && (_currentObjectDefault2 = currentObjectDefault[unique]) !== null && _currentObjectDefault2 !== void 0 && _currentObjectDefault2.length) {
      const length = currentObjectDefault[unique].length;
      for (let index = length - 1; index >= 0; index--) {
        if (!dataSourceUsable.some(data => data[valueExpr] === currentObjectDefault[unique][index][valueExpr])) {
          notExistItem++;
          dataSourceUsable.unshift(currentObjectDefault[unique][index]);
        }
      }
    }
    const length = dataSourceUsable.length;
    let num = 0;
    if (displayExpr && Array.isArray(displayExpr)) {
      displayExpr = displayExpr.join(' - ');
    }
    const keyArr = (_displayExpr2 = displayExpr) === null || _displayExpr2 === void 0 ? void 0 : _displayExpr2.match(separatorPattern);
    for (i; i < length; i++) {
      const data = {
        ...dataSourceUsable[i]
      };
      // Nếu đối tượng đã được hiển thị ở trên rồi thì không hiển thị ra nữa
      if (onLoadMore && i > notExistItem && currentObjectDefault[unique].some(valueObject => valueObject[valueExpr] === data[valueExpr])) continue;
      let displayText = typeof data === 'object' ? keyArr ? renderData(data, keyArr) : data[displayExpr] || data[valueExpr] : data;
      if (pattern && !new RegExp(pattern).test(displayText.normalize())) continue;
      const value = typeof data === 'object' ? data[valueExpr] : data;
      const icon = getIconFromData(data);
      const text = jsx(Typography, {
        type: 'p1'
      }, displayText);
      if (renderItem && typeof renderItem === 'function') {
        displayText = renderItem({
          data,
          index: i
        });
      } else if (subText) {
        displayText = jsx(Fragment, null, jsx(Typography, {
          className: 'DGN-UI-Dropdown-PrimaryText',
          type: 'p1'
        }, displayText), jsx(Typography, {
          className: 'DGN-UI-Dropdown-SubText',
          type: 'p3',
          color: 'text/sub'
        }, typeof subText === 'function' ? subText({
          data,
          index: i
        }) : data[subText] || subText));
      }
      const dropdownItem = document.createElement('div');
      dropdownItem.className = `DGN-UI-Dropdown-Item css-${_DropdownItemCSS.name}`;
      dropdownItem.tabIndex = -1;
      dropdownItem.addEventListener('click', () => onChangeValue(displayText, value, icon, data, i));
      dropdownItem.addEventListener('keypress', e => {
        if (e.key === 'Enter') dropdownItem.firstChild.click();
      });
      let item = null;
      if (multiple && selectBox) {
        const checked = Array.isArray(currentValue[unique]) ? currentValue[unique].includes(value) : [currentValue[unique]].includes(value);
        item = jsx(Checkbox, {
          css: CheckBoxCSS,
          forTreeView: true,
          checked: checked
        }, icon, text);
      } else {
        item = jsx(Fragment, null, icon, text);
      }
      if (!dropdownListRef.current) {
        return;
      }
      ReactDOM.render(item, dropdownListRef.current.appendChild(dropdownItem));
      if (++num === 100) {
        timerRef.current = setTimeout(() => {
          loadMoreItemsDropdown(i + 1, pattern);
        }, 1000);
        break;
      }
    }
  };
  const renderData = (data, keyArr) => {
    const pattern = keyArr.join('|').replace(/([{}])/g, '\\$1');
    const separatorArr = displayExpr.split(new RegExp(pattern));
    let str = '';
    let i = 0;
    for (i; i < keyArr.length; i++) {
      str += separatorArr[i] + (data[keyArr[i].replace(/\W/g, '')] !== undefined ? data[keyArr[i].replace(/\W/g, '')] : keyArr[i]);
    }
    return str + separatorArr[i];
  };
  const getIconFromData = (data, insideChip = false) => {
    if (!iconExpr || iconExpr === 'none') return null;
    let _src;
    if (typeof iconExpr === 'string') _src = data[iconExpr];else {
      let prefix = iconExpr.prefix || '';
      const suffix = iconExpr.suffix || '';
      const url = data[iconExpr.key];
      if (prefix && /^http/i.test(prefix) && /^http/i.test(url)) {
        prefix = '';
      }
      _src = prefix + url + suffix;
    }
    return jsx(Avatar, {
      css: mgr([insideChip ? 0 : 2]),
      disabled: true,
      src: _src,
      width: insideChip ? 20 : 24,
      height: insideChip ? 20 : 24,
      style: {
        ...iconExpr.style
      }
    });
  };
  const customizeWidthDropdown = () => {
    // if (dropdownListRef.current && _isMobile)
    //     dropdownListRef.current.style.maxHeight = `${
    //         Math.min(280, window.innerHeight) - (allowSearch ? 40 : 0)
    //     }px`;
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      if (!ref.current) {
        window.removeEventListener('resize', customizeWidthDropdown);
        return;
      } else {
        const {
          width
        } = ref.current.getBoundingClientRect();
        setPopoverWidth(width);
      }
    }, 300);

    // if (dropdownRef.current) {
    //     dropdownRef.current.style.width = width + 'px';
    // }
    // updatePositionDropdown();
  };

  // const updatePositionDropdown = () => {
  //     if (!formRef.current || !dropdownRef.current) {
  //         // document.removeEventListener('wheel', onWheelHandler);
  //         return;
  //     }
  //     _isMobile
  //         ? updatePosition(formRef.current, dropdownRef.current, null)
  //         : updatePosition(formRef.current, dropdownRef.current, closeDropdown);
  // };

  const handleActionLoadData = isReset => {
    const {
      skip,
      limit,
      strSearch: search
    } = filter.current;
    const params = onLoadMore ? {
      skip,
      limit,
      search
    } : {
      search
    };
    const callbackSave = (error, data) => {
      setLoadingState(false);
      if (error) {
        let _data = {};
        if (error.originalError) {
          const {
            message,
            originalError,
            customMessage,
            code: codeError
          } = error;
          const _customMessage = customMessage && typeof customMessage === 'object' ? customMessage[codeError] : customMessage;
          let messageError = '';
          Object.keys(originalError).forEach(key => {
            messageError += `${key}: ${JSON.stringify(originalError[key], null, 8)}\n`;
          });
          _data = {
            title: getGlobal('error') + (codeError ? `: ${codeError}` : ''),
            subtitle: _customMessage || message || getGlobal('unknownError'),
            description: messageError
          };
        } else {
          var _data$data;
          const message = (data === null || data === void 0 ? void 0 : data.message) || (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.Message) || data;
          _data = {
            description: message || getGlobal('unknownError')
          };
        }
        setPopupDataState(_data);
        popupRef.current.instance.show();
        return false;
      } else if (data) {
        let rows = [];
        if (Array.isArray(data)) {
          rows = data;
        } else {
          rows = data && data.rows ? data.rows : dataSourceState;
          const total = data && data.total ? data.total : data.length;
          setTotalState(total);
        }
        setDataSourceState(isReset ? rows : dataSourceState.concat(rows));
      }
    };
    setLoadingState(true);
    action.loadData(params, callbackSave);
  };
  const onLoadMoreHandler = e => {
    if (loadMoreTimer.current) {
      clearTimeout(loadMoreTimer.current);
    }
    loadMoreTimer.current = setTimeout(() => {
      const {
        scrollTop,
        scrollHeight,
        offsetHeight
      } = e.target;
      if (scrollHeight === Math.ceil(scrollTop) + offsetHeight && dropdownListRef.current) {
        var _dropdownListRef$curr, _currentObjectDefault3;
        const length = ((_dropdownListRef$curr = dropdownListRef.current.children) === null || _dropdownListRef$curr === void 0 ? void 0 : _dropdownListRef$curr.length) - (((_currentObjectDefault3 = currentObjectDefault[unique]) === null || _currentObjectDefault3 === void 0 ? void 0 : _currentObjectDefault3.length) || 0);
        dropdownListRef.current.removeEventListener('scroll', onLoadMoreHandler);
        if (!!onLoadMore && typeof onLoadMore === 'boolean' && action !== null && action !== void 0 && action.loadData) {
          filter.current.skip = length;
          filter.current.limit = limit;
          handleActionLoadData();
        } else !!onLoadMore && onLoadMore({
          skip: length,
          limit: limit
        });
      }
    }, 300);
  };
  const onPreventKeyDownHandler = e => {
    e.preventDefault();
    return false;
  };
  const onChangeInput = e => {
    var _e$target$value;
    if (!dropdownRef.current) return; // Kiểm tra nếu dropdown đóng trước searchDelayTime thì không chạy
    setTxtSearch((_e$target$value = e.target.value) !== null && _e$target$value !== void 0 ? _e$target$value : '');
    // if (searchRef.current) lastSearchRef.current = searchRef.current.value;
    // const dataFilter = getData();
    // dataChosen.current = [...dataFilter].filter(i => [...valueMulti].includes(i?.[valueExpr]));
    if (onInput) {
      // isSearch[unique] = true;
      // const valueInput = e.target.value;
      // const text = (valueInput || e.target.textContent).normalize();
      // if (timeout.current) {
      //     if (timing[unique]) {
      //         clearTimeout(timing[unique]);
      //     }
      // timing[unique] = setTimeout(() => {
      // e.target.value = text;
      onInput(e);
      // e.target.value = valueInput;
      // }, timeout.current || searchDelayTime);
      // } else {
      // e.target.value = text;
      // onInput(e);
      // e.target.value = valueInput;
      // }
      // return;
    }

    if (action !== null && action !== void 0 && action.loadData && !!onLoadMore) {
      filter.current.strSearch = e.target.value;
      handleActionLoadData(true);
    }
    // const value = e.target.value || e.target.textContent;
    // if (
    //     typeof renderSelectedItem === 'function' &&
    //     e.target.childNodes &&
    //     Array.from(e.target.childNodes).some(node => node.toString() !== '[object Text]')
    // ) {
    // const cursor = document.getSelection().anchorOffset;
    // e.target.innerHTML = value;
    // document.getSelection().collapse(e.target, cursor);
    // }
    // if (timing[unique]) clearTimeout(timing[unique]);
    // timing[unique] = setTimeout(() => {
    //     renderDropdown(searchExpr?.length > 0 ? value.normalize() : new RegExp(value.normalize(), 'gim'));
    // }, timeout.current || searchDelayTime);
  };

  const onChangeValue = (displayText, value, icon, data) => {
    if (itemMode === 'treeview') {
      if (valueProp === undefined) {
        setValueMulti(value);
        setValueIntoInput(value);
        setShowClear(clearAble && checkHasValue(value) && !disabled && !readOnly && !loadingState);
      }
      !!onChange && onChange({
        value
      });
      // setTimeout(() => {
      //     updatePositionDropdown();
      // }, 0);
    } else if (multiple) {
      if (!Array.isArray(currentValue[unique])) currentValue[unique] = [];
      // const newValueArr = [...currentValue[unique]];
      const newValueArrState = [...valueMulti];
      if (!newValueArrState.some(v => JSON.stringify(v) === JSON.stringify(value))) {
        // newValueArr.push(value);
        newValueArrState.push(value);
        // if (valueProp === undefined) {
        //     let item = null;
        //     if (typeof renderSelectedItem === 'function') {
        //         item = renderSelextedItem({ data, index });
        //     } else {
        //         item = (
        //             <Chip
        //                 startIcon={icon}
        //                 label={displayText}
        //                 size={itemMultipleSize}
        //                 disabled={disabled}
        //                 clearAble
        //                 onRemove={e => onRemove(e, value)}
        //                 style={{ margin: '3px 0', width: '100%' }}
        //             />
        //         );
        //     }
        //     const el = document.createElement('div');
        //     el.className = 'dropdown-item';
        //     el.style.display = 'flex';
        //     ReactDOM.render(item, inputRef.current.appendChild(el));
        // }
      } else {
        const index = newValueArrState.indexOf(value);
        // newValueArr.splice(index, 1);
        newValueArrState.splice(index, 1);
        // if (valueProp === undefined) {
        //     const nodes = inputRef.current.querySelectorAll('.dropdown-item');
        //     nodes[index]?.remove();
        // }
      }

      setValueMulti(newValueArrState);
      !!onChange && onChange({
        value: newValueArrState,
        data
      });
      // setTimeout(() => {
      //     updatePositionDropdown();
      // }, 0);
    } else {
      const isChanged = currentValue[unique] !== value;
      if (isChanged) {
        if (valueProp === undefined) {
          allValue[unique].push(value);
          setValueIntoInput(value);
          setShowClear(clearAble && checkHasValue(value) && !disabled && !readOnly && !loading);
        }
        !!onChange && onChange({
          value,
          data
        });
      } else {
        // Fix lost icon when select same value
        triggerBlur(false);
      }
    }
    if (closeAfterSelect === true || closeAfterSelect === undefined && !multiple) {
      closeDropdown();
    }
    // else {
    //     setTimeout(() => {
    //         updatePositionDropdown();
    //     }, 0);
    // }
  };

  // const onChangeValueWithCheckbox = e => {
  //     const firstChild = e.currentTarget.firstChild;
  //     if (!firstChild.contains(e.target)) {
  //         firstChild.click();
  //     }
  // };

  const onRemove = (e, value) => {
    var _ref;
    if (readOnly || disabled) return;
    const index = currentValue[unique].findIndex(v => JSON.stringify(v) === JSON.stringify(value));
    if (index !== -1) {
      currentValue[unique].splice(index, 1);
      // setTimeout(() => {
      //     if (dropdownListRef.current && multiple && selectBox && !children) {
      //         const input = dropdownListRef.current.querySelector(`input[value="${value}"]`);
      //         if (input) {
      //             input.checked = false;
      //         }
      //     }
      // e?.parentNode?.remove();
      // }, 0);
      // }, 0);
      // }, 0);
      // setValueMulti([...valueMulti]?.filter(i=>i!==value) || []);
      // !!onChange && onChange({ value: currentValue[unique], removed: value });
    }

    // logic mới
    const newValueArrState = ((_ref = [...valueMulti]) === null || _ref === void 0 ? void 0 : _ref.filter(i => i !== value)) || [];
    setValueMulti(newValueArrState);
    !!onChange && onChange({
      value: newValueArrState,
      removed: value
    });
  };
  const onClear = e => {
    if (disabled || readOnly || loadingState || !clearAble) return;
    currentValue[unique] = multiple ? [] : '';
    if (multiple) {
      setValueMulti([]);
      // inputRef.current.innerHTML = '';
      // if (dropdownListRef.current) {
      //     dropdownListRef.current.querySelectorAll('input').forEach(input => (input.checked = false));
      // }
    } else {
      setValueSingle('');
    }
    // onChangeValue('', '');
    setValueMulti([]);
    setShowClear(false);
    e && e.target && e.target.blur();
    // updatePositionDropdown();
    onInput === null || onInput === void 0 ? void 0 : onInput({
      ...(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current),
      target: {
        value: ''
      }
    });
    !!onChange && onChange({
      value: currentValue[unique]
    });
  };
  const setPreviousValue = () => {
    allValue[unique].pop();
    setValueIntoInput(allValue[unique][allValue[unique].length - 1]);
  };
  const setValueIntoInput = source => {
    if (!source && source !== 0) {
      if (multiple) {
        // inputRef.current.innerHTML = '';
        currentValue[unique] = [];
      } else {
        // if (
        //     typeof renderSelectedItem === 'function' ||
        //     (iconExpr && iconExpr !== 'none' && !isSearch[unique])
        // ) {
        //     inputRef.current.innerHTML = '';
        // } else if (!isSearch[unique]) {
        //     inputRef.current.value = '';
        // }
        currentValue[unique] = '';
      }
      return;
    }
    const length = dataSourceState.length;
    const displayKey = typeof renderSelectedItem === 'string' ? renderSelectedItem : displayExpr;
    if (displayKey && Array.isArray(displayKey)) {
      displayExpr = displayExpr.join(' - ');
    }
    const keyArr = displayKey === null || displayKey === void 0 ? void 0 : displayKey.match(separatorPattern);
    if (multiple) {
      let valueArr = source;
      if (!Array.isArray(valueArr)) {
        valueArr = [valueArr];
      }
      valueArr = [...new Set(valueArr)];
      currentValue[unique] = [];
      // inputRef.current.innerHTML = '';
      valueArr.forEach(v => {
        var _currentObjectDefault4;
        for (let i = 0; i < length; i++) {
          if (!dataSourceState[i]) continue;
          if (typeof dataSourceState[i] === 'object' && dataSourceState[i][valueExpr] === v || dataSourceState[i] === v) {
            setMultipleValueHandler(dataSourceState[i], v, keyArr, i);
            return;
          }
        }
        if ((_currentObjectDefault4 = currentObjectDefault[unique]) !== null && _currentObjectDefault4 !== void 0 && _currentObjectDefault4.length) {
          const itemOfValue = currentObjectDefault[unique].find(valueObject => valueObject[valueExpr] === v || valueObject === v);
          if (itemOfValue) {
            setMultipleValueHandler(itemOfValue, v, keyArr);
          }
        }
      });
    } else {
      var _currentObjectDefault5;
      currentValue[unique] = source;
      for (let i = 0; i < length; i++) {
        if (!dataSourceState[i]) continue;
        if (dataSourceState[i][valueExpr] === source || dataSourceState[i] === source) {
          setSingleValueHandler(dataSourceState[i], keyArr);
          return;
        }
      }
      if ((_currentObjectDefault5 = currentObjectDefault[unique]) !== null && _currentObjectDefault5 !== void 0 && _currentObjectDefault5.length) {
        const itemOfValue = currentObjectDefault[unique].find(valueObject => valueObject[valueExpr] === source || valueObject === source);
        if (itemOfValue) {
          setSingleValueHandler(itemOfValue, keyArr);
          return;
        }
      }
      if (!isSearch[unique]) {
        // inputRef.current.value = source;
      }
    }
  };
  const setMultipleValueHandler = (data, value) => {
    // let item = null;
    // if (typeof renderSelectedItem === 'function') {
    //     item = renderSelectedItem({ data, index });
    // } else {
    //     const icon = getIconFromData(data);
    //     const text = keyArr ? renderData(data, keyArr) : data[renderSelectedItem || displayExpr];
    //     item = (
    //         <Chip
    //             startIcon={icon}
    //             label={text}
    //             size={itemMultipleSize}
    //             disabled={disabled}
    //             clearAble
    //             onRemove={e => onRemove(e, value)}
    //             style={{ margin: '3px 0', width: '100%' }}
    //         />
    //     );
    // }
    // const el = document.createElement('div');
    // el.className = 'dropdown-item';
    // el.style.display = 'flex';
    // ReactDOM.render(item, inputRef.current.appendChild(el));
    currentValue[unique].push(value);
  };
  const setSingleValueHandler = (data, keyArr) => {
    const text = keyArr ? renderData(data, keyArr) : typeof renderSelectedItem === 'string' ? data[renderSelectedItem] : data[displayExpr] || data[valueExpr] || data;
    const renderContent = content => jsx(Typography, {
      type: 'p1',
      lineClamp: multilineSelectedItem ? undefined : 1,
      hoverTooltip: !_isMobile
    }, content);
    if (typeof renderSelectedItem === 'function') {
      // inputRef.current.innerHTML = '';
      const item = renderSelectedItem({
        data
      });
      // const el = document.createElement('div');
      // el.style.display = 'flex';
      // el.style.width = '100%';
      // el.style.minHeight = '24px';
      // if (!multilineSelectedItem) el.style.maxHeight = '24px';
      const el = jsx("div", {
        css: [displayFlex, parseWidth('100%'), parseMinHeight(24), !multilineSelectedItem && parseMaxHeight(24)]
      }, item);
      setValueSingle(el);
      // ReactDOM.render(item, inputRef.current.appendChild(el));
    } else if (iconExpr && iconExpr !== 'none') {
      // inputRef.current.innerHTML = '';
      const icon = getIconFromData(data);
      const valueWithIcon = jsx(Fragment, null, icon && icon, renderContent(text));
      // const el = document.createElement('div');
      // el.style.cssText = 'display: flex; align-items: center; min-height:24px;';
      const el = jsx("div", {
        css: [displayFlex, itemsCenter, parseMinHeight(24)]
      }, valueWithIcon);
      setValueSingle(el);
      // ReactDOM.render(valueWithIcon, inputRef.current.appendChild(el));
    } else {
      // inputRef.current.value = text;
      setValueSingle(text);
    }
  };
  useImperativeHandle(reference, () => {
    const currentRef = ref.current || {};
    const _instance = {
      ...action,
      closeDropdown: () => {
        closeDropdown();
      },
      showDropdown: () => {
        setOpenState(true);
      },
      onClear,
      setPreviousValue,
      setValue: value => {
        if (allValue[unique][allValue[unique].length - 1] !== value) {
          allValue[unique].push(value);
        }
        setValueIntoInput(value);
      }
    }; // methods
    _instance.__proto__ = {}; // hidden methods
    currentRef.instance = _instance;
    // keep old method
    currentRef.closeDropdown = () => closeDropdown();
    currentRef.showDropdown = () => setOpenState(true);
    currentRef.onClear = onClear;
    currentRef.setPreviousValue = setPreviousValue;
    currentRef.setValue = value => {
      if (allValue[unique][allValue[unique].length - 1] !== value) {
        allValue[unique].push(value);
      }
      setValueIntoInput(value);
    };
    currentRef.DOM = ref.current;
    return currentRef;
  });
  useEffect(() => {
    setLoadingState(loading);
  }, [loading]);
  useEffect(() => {
    setTotalState(total);
  }, [total]);
  useEffect(() => {
    setDataSourceState(dataSource);
  }, [dataSource]);
  useEffect(() => {
    setShowClear(clearAble && checkHasValue(valueProp !== null && valueProp !== void 0 ? valueProp : defaultValue) && !disabled && !readOnly && !loadingState);
  }, [clearAble, valueProp, defaultValue, disabled, readOnly, loadingState]);
  useEffect(() => {
    if (valueObjectDefault) {
      if (Array.isArray(valueObjectDefault)) {
        currentObjectDefault[unique] = [...valueObjectDefault];
      } else if (typeof valueObjectDefault === 'object') {
        currentObjectDefault[unique] = Object.keys(valueObjectDefault).length !== 0 ? [valueObjectDefault] : [];
      }
    } else {
      currentObjectDefault[unique] = [];
    }
    return () => {
      currentObjectDefault[unique] = null;
    };
  }, [valueObjectDefault]);
  useEffect(() => {
    allValue[unique] = [];
    if (defaultValue !== undefined && JSON.stringify(defaultValue) !== '[]') {
      setValueIntoInput(defaultValue);
      setShowClear(clearAble && checkHasValue(defaultValue) && !disabled && !readOnly && !loadingState);
    }
    if (action !== null && action !== void 0 && action.loadData) handleActionLoadData();
    return () => {
      allValue[unique] = null;
      closeDropdown();
    };
  }, []);

  // useEffect(() => {
  //     if (searchDelayTime) {
  //         if (searchDelayTime === true) searchDelayTime = getGlobal('delayOnInput');
  //         const units = {
  //             m: 60000,
  //             s: 1000,
  //             ms: 1,
  //         };
  //         timeout.current =
  //             typeof searchDelayTime === 'number'
  //                 ? searchDelayTime
  //                 : (searchDelayTime.match(/[^a-z]+/i)?.[0] || 1) *
  //                   units[searchDelayTime.match(/ms|s|m/i)?.[0] || 's'];
  //         return () => {
  //             timeout.current = null;
  //         };
  //     }
  // }, [searchDelayTime]);

  useEffect(() => {
    if (allValue[unique][allValue[unique].length - 1] !== valueProp) {
      allValue[unique].push(valueProp);
    }
    if (multiple && valueProp) {
      setValueMulti(convertData(valueProp, valueExpr));
    }
    // Close dropdown treeview by children when select item
    if (children && (closeAfterSelect === true || closeAfterSelect === undefined && !multiple)) {
      closeDropdown();
    }
  }, [valueProp]);
  useEffect(() => {
    if (valueProp !== undefined && (!dropdownListRef.current || children || JSON.stringify(valueProp) !== JSON.stringify(currentValue[unique]))) {
      setValueIntoInput(valueProp);
    }
  }, [valueProp, dataSourceState]);
  useEffect(() => {
    inputRef.current.readOnly = readOnly || inputProps.readOnly;
    if (!readOnly && !disabled) {
      !!onLoadMore && dropdownListRef.current && dropdownListRef.current.addEventListener('scroll', onLoadMoreHandler);
    }
    if (disabled || readOnly || children) {
      inputRef.current.addEventListener('keydown', onPreventKeyDownHandler);
    } else {
      inputRef.current.addEventListener('keydown', onKeyDown);
    }
    return () => {
      if (!ref.current || !inputRef.current || !iconRef.current) return;
      if (disabled || readOnly || children) {
        inputRef.current.removeEventListener('keydown', onPreventKeyDownHandler);
      } else {
        inputRef.current.removeEventListener('keydown', onKeyDown);
      }
      closeDropdown();
    };
  }, [disabled, readOnly, displayExpr, multiple, allowSearch, viewType, closeAfterSelect, selectBox]);
  useEffect(() => {
    if (!disabled && !readOnly) {
      inputRef.current.addEventListener('click', onClickInput);
      inputRef.current.addEventListener('input', onChangeInput);
    }
    return () => {
      if (!disabled && !readOnly && inputRef.current) {
        inputRef.current.removeEventListener('click', onClickInput);
        inputRef.current.removeEventListener('input', onChangeInput);
      }
    };
  }, [onChange, children]);
  useEffect(() => {
    if (!disabled && !readOnly) {
      inputRef.current.addEventListener('click', onClickInput);
    }
    if (dropdownListRef.current) {
      var _dropdownListRef$curr2, _dropdownListRef$curr3, _currentObjectDefault6;
      if (!disabled && !readOnly) {
        inputRef.current.addEventListener('input', onChangeInput);
      }
      const length = (_dropdownListRef$curr2 = dropdownListRef.current) === null || _dropdownListRef$curr2 === void 0 ? void 0 : (_dropdownListRef$curr3 = _dropdownListRef$curr2.children) === null || _dropdownListRef$curr3 === void 0 ? void 0 : _dropdownListRef$curr3.length;
      if (length < dataSourceState.length + ((_currentObjectDefault6 = currentObjectDefault[unique]) === null || _currentObjectDefault6 === void 0 ? void 0 : _currentObjectDefault6.length) && !isSearch[unique]) {
        loadMoreItemsDropdown(length);
        !!onLoadMore && dataSourceState.length < totalState && dropdownListRef.current.addEventListener('scroll', onLoadMoreHandler);
      } else {
        isSearch[unique] = false;
      }
    } else {
      if (!multiple && !disabled && !readOnly) {
        inputRef.current.addEventListener('input', onChangeInput);
      }
    }
    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener('input', onChangeInput);
        inputRef.current.removeEventListener('click', onClickInput);
      }
      !!dropdownListRef.current && dropdownListRef.current.removeEventListener('scroll', onLoadMoreHandler);
    };
  }, [dataSourceState]);
  useLayoutEffect(() => {
    if (ref.current) {
      const {
        width
      } = ref.current.getBoundingClientRect();
      setPopoverWidth(width);
    }
  });
  /* End handler */

  /* Start component */
  const EmptyDataText = jsx("div", {
    css: _DropdownItemCSS,
    className: 'no-data'
  }, noDataText);
  const LabelView = useMemo(() => label ? jsx(Label, {
    required: required,
    disabled: disabled,
    ...labelProps
  }, label) : null, [label, required, disabled, labelProps]);
  const getData = () => {
    let dataFilter = JSON.parse(JSON.stringify(dataSourceState));
    if (Array.isArray(valueObjectDefault)) {
      dataFilter = [...dataFilter, ...dataChosen.current, ...valueObjectDefault];
    } else if (typeof valueObjectDefault === 'object') {
      dataFilter = [...dataFilter, ...dataChosen.current, {
        ...valueObjectDefault
      }];
    }
    return dataFilter;
  };
  const InputView = useMemo(() => {
    return jsx("div", {
      css: _DropdownFormCSS,
      ref: formRef,
      className: classNames('DGN-UI-Dropdown-Form', openState && 'dropdown-showing')
    }, jsx("div", {
      css: _InputCSS,
      className: 'DGN-UI-Dropdown-Form-Input'
    }, multiple && valueMulti !== null && valueMulti !== void 0 && valueMulti.length ? jsx("div", {
      ...inputProps,
      style: inputStyle,
      ref: inputRef,
      css: [_DropdownInputCSS, gap([0.5])],
      className: classNames('dgn-dropdown-multiple', inputProps.className),
      onChange: e => {
        e.preventDefault();
        return false;
      }
    }, valueMulti.map((vl, index) => {
      let dataFilter = getData();
      const data = dataFilter.find(v => v[valueExpr] === vl || v === vl);
      let text = '';
      if (data || data === 0) {
        displayExpr = displayExpr || valueExpr;
        // displayExpr =
        //     typeof renderSelectedItem === 'string'
        //         ? renderSelectedItem
        //         : displayExpr || valueExpr;
        let mask = data === null || data === void 0 ? void 0 : data[displayExpr];

        // convert {id} - {name} to {<data[id]>} - {<data[name]>}
        if (!mask && regexBetween.test(displayExpr)) {
          var _displayExpr3;
          mask = (_displayExpr3 = displayExpr) === null || _displayExpr3 === void 0 ? void 0 : _displayExpr3.replace(regexBetween, _ => data[_]);
        } else if (!mask) {
          mask = typeof data !== 'object' ? data : '';
        }
        text = mask.toString().replace(regexInclude, '');
      }
      let item;
      if (typeof renderSelectedItem === 'function') {
        item = renderSelectedItem({
          data,
          index
        });
      } else {
        item = jsx(Chip, {
          css: [parseWidth('100%'), parseMaxWidth('max-content')],
          key: index,
          startIcon: getIconFromData(data, true),
          label: text,
          size: 'medium',
          disabled: disabled,
          clearAble: !readOnly && !disabled,
          onRemove: e => onRemove(e, vl)
        });
      }
      return item;
    })) : typeof renderSelectedItem === 'function' || iconExpr && iconExpr !== 'none' ? jsx("div", {
      ...inputProps,
      style: inputStyle,
      ref: inputRef,
      css: _DropdownInputCSS,
      className: classNames('dgn-dropdown-multiple', inputProps.className),
      onKeyDown: e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          return false;
        }
      }
    }, valueSingle) : jsx("div", {
      css: _DropdownInputCSS,
      onClick: onClickInput
    }, jsx(Typography, {
      ref: inputRef,
      hoverTooltip: true,
      lineClamp: multilineSelectedItem ? undefined : 1,
      type: 'p1',
      style: {
        lineHeight: multiple ? '30px' : '24px'
      },
      tabIndex: -1
    }, valueSingle))), jsx("div", {
      ref: iconRef,
      css: _IconCSS,
      className: 'DGN-UI-Dropdown-Icon'
    }, loadingState ? jsx(CircularProgress, {
      size: 24
    }) : null, showClear ? jsx(ButtonIcon, {
      css: mgr([1]),
      viewType: 'ghost',
      name: 'Close',
      onClick: onClear
    }) : null, !loadingState ? jsx(ButtonIcon, {
      key: openState,
      css: animation,
      viewType: 'ghost',
      name: openState ? 'ArrowUp' : 'ArrowDown',
      onClick: setShowDropdown,
      disabled: disabled || readOnly
    }) : null));
  }, [openState, showClear, valueSingle, valueMulti, loadingState, dataSourceState, clearAble, dataSource, disabled, displayExpr, inputProps, inputStyle, multilineSelectedItem, multiple, onChange, placeholder, readOnly, renderSelectedItem, valueExpr, valueObjectDefault, viewType]);
  const ErrorView = useMemo(() => {
    return error ? jsx(HelperText, {
      ...helperTextProps,
      disabled: disabled
    }, error) : null;
  }, [disabled, error, helperTextProps]);
  const DropdownView = useMemo(() => {
    return jsx(Popover, {
      css: [mgt([1]), overflowHidden],
      ref: dropdownRef,
      open: openState,
      anchor: ref.current,
      width: popoverWidth,
      onClose: closeDropdown
    }, showDropdown());
    // return openState ? createPortal(showDropdown(), document.body) : null;
  }, [openState, popoverWidth, valueMulti, loadingState, dataSourceState, dataSource, maximumSelectionLength, multilineSelectedItem, multiple, selectBox, txtSearch]);
  /* End component */

  return jsx(Fragment, null, jsx("div", {
    ref: ref,
    css: _DropdownRootCSS,
    style: style,
    className: classNames('DGN-UI-Dropdown', className, error && 'error', loadingState && 'dgn-dropdown-loading', disabled ? 'disabled' : readOnly && 'readOnly')
  }, LabelView, InputView, ErrorView), DropdownView, jsx(Popup, {
    ref: popupRef,
    type: 'danger',
    ...popupDataState
  }));
}));

/* Start styled */
const InputCSS = (multiple, renderSelectedItem) => css`
    ${displayFlex};
    ${positionRelative};
    ${parseWidth(!multiple && renderSelectedItem ? 'calc(100% - 34px)' : '100%')};
`;
const DropdownInputCSS = (viewType, multiple, placeholder, disabled, readOnly, multilineSelectedItem) => css`
    ${displayFlex};
    ${itemsCenter};
    ${outlineNone};
    ${bgColor('transparent')};
    ${borderNone};
    ${paragraph1};
    ${disabled ? cursorNotAllowed : readOnly ? cursorDefault : cursorPointer};
    ${parseWidth('100%')};
    ${textColor('text/main')};
    ${pdt(0)};
    ${pdb([viewType !== 'outlined' ? 0 : 'inherit'])};
    ${pdl([viewType !== 'outlined' ? 0 : 4])};
    ${parseMinHeight(multiple ? 30 : 24)};
    &.dgn-dropdown-multiple {
        ${displayFlex};
        ${flexWrap};
        ${overflowHidden};
        ${breakWord};
        ${!multiple && css`
            ${parseMinHeight(24)};
            ${parseMaxWidth('100%')};
            ${!multilineSelectedItem && parseMaxHeight(24)};
        `};
        &::after {
            ${displayFlex};
            ${flexRow};
            ${positionAbsolute};
            ${itemsCenter};
            ${justifyCenter};
            content: '${placeholder}';
            ${textColor('text/sub')};
        }
        &:not(:empty)::after {
            ${invisible};
        }
    }
    &:focus {
        ${bgColor('transparent')};
    }
    .dropdown-item {
        &:not(:last-child) {
            ${mgr([1.25])};
        }
        svg {
            ${boxBorder};
            ${pd([0.5])};
        }
    }
    .DGN-UI-Typography {
        ${disabled && textColor('system/disabled')};
    }
`;
const IconCSS = viewType => css`
    ${displayFlex};
    ${itemsCenter};
    ${mgl([2])};
    ${mgr([viewType !== 'outlined' ? 0 : 4])};
`;
const DropdownFormCSS = (viewType, multiple, disabled, placeholder, DropdownInputCSSName) => viewType !== 'outlined' ? css`
              ${displayFlex};
              ${flexRow};
              ${itemsCenter};
              ${positionRelative};
              ${boxBorder};
              ${parseWidth('100%')};
              ${pdy([multiple ? 0.25 : 1])};
              ${!disabled && css`
                  &:not(:focus-within):hover {
                      &::before {
                          ${borderBottomColor('system/active')};
                      }
                      .css-${DropdownInputCSSName} {
                          ${textColor('system/active')};
                      }
                  }
              `}
              &:focus-within {
                  ${borderBottomColor('line/focus')};
                  &::after {
                      ${borderBottomColor('inherit')};
                      transform: scaleX(1);
                  }
                  .css-${DropdownInputCSSName} {
                      ${textColor('system/active')};
                  }
              }
              span:empty:before {
                  content: '${placeholder}';
                  ${parseHeight('100%')};
                  ${overflowHidden};
                  ${textColor('text/sub')};
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
              }
              &::placeholder {
                  ${textColor('text/sub')};
              }
              &::before {
                  ${positionAbsolute};
                  content: '';
                  ${insetX(0)};
                  ${bottom(0)};
                  ${viewType === 'underlined' && borderBottom(1, disabled ? 'system/disabled' : 'system/rest')}
              }
              &::after {
                  ${positionAbsolute};
                  content: '';
                  ${insetX(0)};
                  ${bottom(-1)};
                  ${borderBottom(2, 'transparent')};
                  transform: scaleX(0);
                  transform-origin: center;
                  transition: all 0.2s ease;
              }
          ` : css`
              ${displayFlex};
              ${flexRow};
              ${itemsCenter};
              ${positionRelative};
              ${borderRadius(4)};
              ${boxBorder};
              ${border(1, disabled ? 'system/disabled' : 'system/rest')};
              ${parseWidth('100%')};
              ${parseMinHeight(40)};
              ${mgt([0.5])};
              ${!disabled && css`
                  &:not(:focus-within):hover {
                      ${bgColor('fill/hover')};
                      ${borderColor('system/active')};
                      input {
                          ${bgColor('fill/hover')};
                      }
                  }
              `}
              &:focus-within {
                  ${borderColor('line/focus')};
              }
              span:empty:before {
                  content: '${placeholder}';
                  ${parseHeight('100%')};
                  ${overflowHidden};
                  ${textColor('text/sub')};
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
              }
              &::placeholder {
                  ${textColor('text/sub')};
              }
              &::after {
                  ${positionAbsolute};
                  ${pointerEventsNone};
                  ${borderRadius(4)};
                  ${border(2, 'transparent')};
                  ${inset(-2)};
                  content: '';
              }
          `;
const DropdownListCSS = loading => css`
    ${displayBlock};
    ${positionRelative};
    ${boxBorder};
    ${borderRadius(4)};
    ${parseWidth('100%')};
    ${parseMaxHeight(280)};
    ${loading ? overflowHidden : overflowAuto};
    ${bgColor('system/white')};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    ${z(1)};
    &::-webkit-scrollbar {
        ${borderRadius(4)};
        ${parseWidth(24)};
        ${bgColor('system/white')};
    }
    &::-webkit-scrollbar-thumb {
        ${borderRadius(24)};
        ${border(8, 'transparent')};
        ${bgColor('fill/scrollbar-tabbar')};
        mix-blend-mode: normal;
        background-clip: content-box;
    }
    .DGN-UI-TreeView {
        ${pd([0.25])};
    }
`;
const DropdownItemCSS = (multiple, selectBox) => css`
    ${displayFlex};
    ${flexRow};
    ${positionRelative};
    ${itemsCenter};
    ${justifyStart};
    ${boxBorder};
    ${cursorPointer};
    ${userSelectNone};
    ${parseMinHeight(40)};
    ${parseWidth('100%')};
    ${bgColor('system/white')};
    ${pd([2, multiple && selectBox ? 0 : 4])};
    ${textColor('text/main')};
    &.no-data {
        ${justifyCenter};
        ${cursorDefault};
        ${italic};
    }
    &:not(.no-data):hover,
    &:not(.no-data):focus {
        ${outlineNone};
        ${bgColor('fill/hover')};
        ${textColor('system/active')};
    }
`;
const DropdownRootCSS = (DropdownFormCSSName, DropdownInputCSSName) => css`
    ${displayBlock};
    ${positionRelative};
    ${mgb([5])};
    ${parseHeight('max-content')};
    &.error {
        .css-${DropdownFormCSSName} {
            ${borderColor('semantic/danger')};
            path {
                ${fill('semantic/danger')};
            }
            &::before {
                ${borderColor('semantic/danger')};
            }
        }
    }
    &.dgn-dropdown-loading,
    &.disabled {
        .css-${DropdownFormCSSName} {
            ${borderColor('system/disabled')};
            &::before {
                ${borderColor('system/disabled')};
            }
        }
    }
    &.readOnly {
        .css-${DropdownInputCSSName} {
            .dropdown-item {
                ${pointerEventsNone};
            }
        }
    }
`;

// const DropdownCSS = (topVl, leftVl, width, isMobile, allowSearch) => css`
//     ${positionFixed};
//     ${parseWidth(width)};
//     ${top(topVl)};
//     ${left(leftVl)};
//     ${bgColor('system/white')};
//     ${z(1)};
//     ${isMobile &&
//     allowSearch &&
//     css`
//         ${parseHeight('max-content')};
//         ${displayFlex};
//         ${flexColReverse};
//         ${bottom(0)};
//         ${top('auto')};
//     `}
// `;

const LoadingProgressCSS = css`
    ${displayFlex};
    ${flexRow};
    ${justifyCenter};
    ${itemsCenter};
    ${positionAbsolute};
    ${borderRadius(4)};
    ${parseWidthHeight('100%')}
    ${bgColor('rgba(255, 255, 255, 0.6)')};
    ${z(2)};
    ${top(0)};
`;
const DisabledCSS = css`
    pointer-events: none !important;
    opacity: 0.4 !important;
`;
const CheckBoxCSS = css`
    ${parseWidthHeight('100%')};
    ${pd([0, 4])};
`;
/* End styled */

Dropdown.defaultProps = {
  allowSearch: true,
  className: '',
  clearAble: false,
  dataSource: [],
  disabled: false,
  displayExpr: 'name',
  error: '',
  iconExpr: 'none',
  inputProps: {},
  itemMode: 'normal',
  label: '',
  limit: 50,
  loading: false,
  multilineSelectedItem: false,
  multiple: false,
  noDataText: getGlobal('noDataText'),
  onInput: null,
  placeholder: getGlobal('dropdownPlaceholder'),
  readOnly: false,
  required: false,
  searchDelayTime: getGlobal('delayOnInput'),
  searchMode: 'contains',
  total: Number.MAX_SAFE_INTEGER,
  valueExpr: 'id',
  viewType: 'underlined'
};
Dropdown.propTypes = {
  action: PropTypes.shape({
    loadData: PropTypes.func
  }),
  /** If `true`, display input box search. */
  allowSearch: PropTypes.bool,
  /** The contents in Dropdown box (Exp: TreeView). */
  children: PropTypes.node,
  /** Class for component. */
  className: PropTypes.string,
  /** If `true`, display clear icon.*/
  clearAble: PropTypes.bool,
  /** If `true`, dropdown will close after select an item. */
  closeAfterSelect: PropTypes.bool,
  /** The array of elements that appear in the dropdown list. */
  dataSource: PropTypes.array,
  /** Default value displayed when first render. */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  /** If `true`, the component is disabled. */
  disabled: PropTypes.bool,
  /** Field name used for text display in dropdown list.<br/>
   * Example: 'name', '{id} - {name}', '{age} age(s)'<br/>
   * Note: don't use 'id - name', return undefined
   */
  displayExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  /**  Style inline of dropdown items. */
  dropdownItemStyle: PropTypes.object,
  /** Error displayed below input. */
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Props applied to the [HelperText](https://core.diginet.com.vn/ui/?path=/story/form-control-text-helpertext) element. */
  helperTextProps: PropTypes.object,
  /** Field name used for icon display.<br/>
   * Example:<br/>
   * &nbsp;&nbsp;string: 'icon'<br/>
   * &nbsp;&nbsp;object: {<br/>
   * &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;key: 'icon',<br/>
   * &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;prefix: 'https://imglink.com',<br/>
   * &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;suffix: '.jpg'<br/>
   * &nbsp;&nbsp;}
   */
  iconExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    key: PropTypes.string,
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    style: PropTypes.object
  })]),
  /** Attributes applied to the input element. */
  inputProps: PropTypes.object,
  /**  Style inline of input element. */
  inputStyle: PropTypes.object,
  /** The mode of item when rendering. */
  itemMode: PropTypes.oneOf(['normal', 'table', 'treeview']),
  /** The label of the input. */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** [Props](https://core.diginet.com.vn/ui/?path=/docs/form-control-text-label--simple) of label. */
  labelProps: PropTypes.object,
  /** Number of items that are rendered each time. */
  limit: PropTypes.number,
  /** If `true`, the loading indicator is shown. */
  loading: PropTypes.bool,
  /** Set restrictions regarding the maximum number of options that can be selected. (Use with prop `multiple`) */
  maximumSelectionLength: PropTypes.number,
  /** If `true`, show multi-line selected item(s). */
  multilineSelectedItem: PropTypes.bool,
  /** If `true`, value must be an array and the dropdown will support multiple selections. */
  multiple: PropTypes.bool,
  /** Specifies a text string shown when there is no data. */
  noDataText: PropTypes.string,
  /** Callback fired when the value changes. */
  onChange: PropTypes.func,
  /** Callback fired when dropdown closed. */
  onClosed: PropTypes.func,
  /** Callback fired when the input value changes.<br/>
   * if undefined: the filter function will run (default)
   */
  onInput: PropTypes.func,
  /** Callback fired when key down input */
  onKeyDown: PropTypes.func,
  /** Callback fired when scroll near the end. */
  onLoadMore: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  /** The short hint displayed in the input before the user select a value. */
  placeholder: PropTypes.string,
  /** If `true`, the component is read-only. */
  readOnly: PropTypes.bool,
  /** Function displays items by custom.<br/>
   * renderItem={(data, index) => data.name + ' - ' + data.role}<br/>
   * --> such as: displayExpr={'name - role'}
   */
  renderItem: PropTypes.func,
  /** Function or field name used for display selected items, example:<br/>
   * renderSelectedItem={(data, index) => index + ' - ' + data.name}<br/>
   */
  renderSelectedItem: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  /** If `true`, the label will indicate that the input is required. */
  required: PropTypes.bool,
  /**
   * Duration wait enter search content on search.<br/>
   * Example: 700 -> 700ms, '700ms' -> 700ms, '0.7s' -> 700ms, '1m' -> 60000ms
   * If `true`, used default delayOnInput.
   */
  searchDelayTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  /** Specifies a data object's field name or an expression whose value is compared to the search string. */
  searchExpr: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  /** Specifies a comparison operation used to search items. */
  searchMode: PropTypes.oneOf(['contains', 'startswith', 'equals']),
  /** If `true`, show checkbox in each dropdown item. */
  selectBox: PropTypes.bool,
  /** Style inline of component. */
  style: PropTypes.object,
  /** Display sub content. */
  subText: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /** The total number of items in the dropdown list. */
  total: PropTypes.number,
  /** Used to identify the parent key (only used for `itemMode` is 'treeview'). */
  treeViewID: PropTypes.string,
  /** Used for mapping into a nested list (only used for `itemMode` is 'treeview'). */
  treeViewParentID: PropTypes.string,
  /** The displayed value of component. */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  /** The field name used for the returned result. */
  valueExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** An object default for value (use for load more). */
  valueObjectDefault: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /**The variant to use. */
  viewType: PropTypes.oneOf(['underlined', 'outlined', 'none'])
  /**
   * ref methods
   *
   * how to get component element? ref.current
   *
   * how to call method? ref.current.instance.{method}
   *
   * * showDropdown(): Show dropdown
   * * closeDropdown(): Close dropdown
   * * onClear(): Clear selected value
   * * setPreviousValue(): Set value to previous value
   * * setValue(value): Set value of dropdown
   *  * @param {value} - string || number || array
   */
};

export default Dropdown;